module.exports = {"532529101":"迤萨镇","532529102":"甲寅镇","532529103":"宝华镇","532529104":"乐育镇","532529105":"浪堤镇","532529203":"洛恩乡","532529204":"石头寨乡","532529205":"阿扎河乡","532529208":"大羊街乡","532529209":"车古乡","532529210":"架车乡","532529211":"垤玛乡","532529212":"三村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532529.json
// module id = 2769
// module chunks = 0